<div>
    <!-- Back to Search Button -->
    <div class="flex justify-start mb-4">
        <button mat-button (click)="backToSearch.emit()" class="flex items-center text-gray-700 hover:text-gray-900">
            <mat-icon class="mr-2">arrow_back</mat-icon>
            Back to Auto Search
        </button>
    </div>
    <div class="mt-6">
        <!-- Bulk Actions Header -->
        <!-- Radio button selector for Company/Individual -->
        <div class="flex justify-between items-center">
            <div class="flex justify-left mb-2">
                <mat-radio-group [(ngModel)]="searchBy" (change)="reset()" class="flex gap-2">
                    <mat-radio-button value="Companies" class="radio-option-traditional">
                        <div class="flex items-center gap-2 px-4 py-2 border border-gray-300 rounded-lg">
                            <div class="radio-indicator"></div>
                            <mat-icon class="text-[18px] w-[18px] h-[18px]">business</mat-icon>
                            <span class="font-medium text-[15px] font-poppins">Company</span>
                        </div>
                    </mat-radio-button>
                    <mat-radio-button value="Individuals" class="radio-option-traditional">
                        <div class="flex items-center gap-2 px-4 py-2 border border-gray-300 rounded-lg">
                            <div class="radio-indicator"></div>
                            <mat-icon class="text-[18px] w-[18px] h-[18px]">person</mat-icon>
                            <span class="font-medium text-[15px] font-poppins">Individual</span>
                        </div>
                    </mat-radio-button>
                    <mat-radio-button value="Vessels" class="radio-option-traditional">
                        <div class="flex items-center gap-2 px-4 py-2 border border-gray-300 rounded-lg">
                            <div class="radio-indicator"></div>
                            <mat-icon class="text-[18px] w-[18px] h-[18px]">directions_boat</mat-icon>
                            <span class="font-medium text-[15px] font-poppins">Vessel</span>
                        </div>
                    </mat-radio-button>
                </mat-radio-group>
            </div>
            <div class="flex justify-between items-center mb-2">
                <div class="flex gap-2">
                    <button mat-stroked-button color="primary" (click)="openCsvUploadDialog()">
                        <mat-icon>upload_file</mat-icon>
                        Upload CSV
                    </button>
                    <button mat-stroked-button color="warn"
                        (click)="searchBy === 'Companies' ? clearAllCompanies() : clearAllIndividuals()"
                        [disabled]="getEntityCount() === 0">
                        <mat-icon>clear_all</mat-icon>
                        Clear All
                    </button>
                </div>
            </div>
        </div>

        <!-- Company Bulk Table -->
        <div *ngIf="searchBy === 'Companies'" class="bulk-table-container">
            <div class="overflow-x-auto">
                <table mat-table [dataSource]="companyDataSource" class="w-full">

                    <!-- Company Name Column -->
                    <ng-container matColumnDef="companyName">
                        <th mat-header-cell *matHeaderCellDef class="font-semibold">Company Name *</th>
                        <td mat-cell *matCellDef="let element; let i = index">
                            <mat-form-field appearance="outline" class="w-full table-form-field"
                                [class.invalid-field]="isFieldInvalid(element, 'companyName')">
                                <input matInput [formControl]="element.get('companyName')"
                                    placeholder="Enter company name">
                            </mat-form-field>
                        </td>
                    </ng-container>

                    <!-- Country Column -->
                    <ng-container matColumnDef="country">
                        <th mat-header-cell *matHeaderCellDef class="font-semibold">Country *</th>
                        <td mat-cell *matCellDef="let element; let i = index">
                            <mat-form-field appearance="outline" class="w-full table-form-field"
                                [class.invalid-field]="isFieldInvalid(element, 'country')">
                                <input matInput [value]="element.get('countryDisplay')?.value"
                                    (input)="element.get('countryDisplay')?.setValue($any($event.target).value)"
                                    [matAutocomplete]="countryAuto" placeholder="Type to search">
                            </mat-form-field>
                            <mat-autocomplete #countryAuto="matAutocomplete"
                                (optionSelected)="onBulkCountrySelection($event.option.value, element)">
                                <mat-option
                                    *ngFor="let country of getFilteredCountries(element.get('countryDisplay')?.value || '')"
                                    [value]="country">
                                    <div class="flex items-center gap-2">
                                        <span class="text-lg">{{ country.flag }}</span>
                                        <span>{{ country.name }}</span>
                                    </div>
                                </mat-option>
                            </mat-autocomplete>
                        </td>
                    </ng-container>

                    <!-- Address Column -->
                    <ng-container matColumnDef="address">
                        <th mat-header-cell *matHeaderCellDef class="font-semibold">Address *</th>
                        <td mat-cell *matCellDef="let element">
                            <mat-form-field appearance="outline" class="w-full table-form-field"
                                [class.invalid-field]="isFieldInvalid(element, 'address')">
                                <input matInput [formControl]="element.get('address')" placeholder="Enter address">
                            </mat-form-field>
                        </td>
                    </ng-container>

                    <!-- Company Size Column -->
                    <ng-container matColumnDef="companySize">
                        <th mat-header-cell *matHeaderCellDef class="font-semibold">Size</th>
                        <td mat-cell *matCellDef="let element">
                            <mat-form-field appearance="outline" class="w-full table-form-field"
                                [class.invalid-field]="isFieldInvalid(element, 'companySize')">
                                <mat-select [formControl]="element.get('companySize')">
                                    <mat-option value="Small">Small</mat-option>
                                    <mat-option value="Medium">Medium</mat-option>
                                    <mat-option value="Large">Large</mat-option>
                                    <mat-option value="Very Large">Very Large</mat-option>
                                </mat-select>
                            </mat-form-field>
                        </td>
                    </ng-container>

                    <!-- Market Column -->
                    <ng-container matColumnDef="market">
                        <th mat-header-cell *matHeaderCellDef class="font-semibold">Market</th>
                        <td mat-cell *matCellDef="let element">
                            <mat-form-field appearance="outline" class="w-full table-form-field"
                                [class.invalid-field]="isFieldInvalid(element, 'market')">
                                <mat-select [formControl]="element.get('market')">
                                    <mat-option *ngFor="let market of markets" [value]="market">
                                        {{ market }}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </td>
                    </ng-container>

                    <!-- Actions Column -->
                    <ng-container matColumnDef="actions">
                        <th mat-header-cell *matHeaderCellDef class="font-semibold">Actions</th>
                        <td mat-cell *matCellDef="let element; let i = index">
                            <div class="flex gap-1">
                                <button mat-icon-button color="warn" (click)="removeCompanyEntity(i)"
                                    matTooltip="Remove company" [disabled]="getEntityCount() === 1">
                                    <mat-icon>delete</mat-icon>
                                </button>
                                <div class="flex items-center justify-center">
                                    <mat-icon *ngIf="hasRowValidationErrors(element)"
                                        class="text-red-500 flex items-center justify-center"
                                        matTooltip="Has validation errors">
                                        error
                                    </mat-icon>
                                    <mat-icon *ngIf="!hasRowValidationErrors(element)" class="text-green-500"
                                        matTooltip="Valid">
                                        check_circle
                                    </mat-icon>
                                </div>
                            </div>
                        </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="companyDisplayedColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: companyDisplayedColumns;"
                        [class.error-row]="hasRowValidationErrors(row)"></tr>
                </table>
            </div>

            <!-- Add Company Button -->
            <div class="flex justify-left mt-2 ml-2">
                <button mat-stroked-button (click)="addCompanyEntity()" class="flex items-center gap-2">
                    <mat-icon>add</mat-icon>
                    Add Another Company
                </button>
            </div>
        </div>

        <!-- Individual Bulk Table -->
        <div *ngIf="searchBy === 'Individuals'" class="bulk-table-container">
            <div class="overflow-x-auto">
                <table mat-table [dataSource]="individualDataSource" class="w-full">

                    <!-- Full Name Column -->
                    <ng-container matColumnDef="fullName">
                        <th mat-header-cell *matHeaderCellDef class="font-semibold">Full Name *</th>
                        <td mat-cell *matCellDef="let element">
                            <mat-form-field appearance="outline" class="w-full table-form-field"
                                [class.invalid-field]="isFieldInvalid(element, 'fullName')">
                                <input matInput [formControl]="element.get('fullName')" placeholder="Enter full name">
                            </mat-form-field>
                        </td>
                    </ng-container>

                    <!-- Country Column -->
                    <ng-container matColumnDef="country">
                        <th mat-header-cell *matHeaderCellDef class="font-semibold">Country *</th>
                        <td mat-cell *matCellDef="let element">
                            <mat-form-field appearance="outline" class="w-full table-form-field"
                                [class.invalid-field]="isFieldInvalid(element, 'country')">
                                <input matInput [value]="element.get('countryDisplay')?.value"
                                    (input)="element.get('countryDisplay')?.setValue($any($event.target).value)"
                                    [matAutocomplete]="countryAutoInd" placeholder="Type to search">
                            </mat-form-field>
                            <mat-autocomplete #countryAutoInd="matAutocomplete"
                                (optionSelected)="onBulkCountrySelection($event.option.value, element)">
                                <mat-option
                                    *ngFor="let country of getFilteredCountries(element.get('countryDisplay')?.value || '')"
                                    [value]="country">
                                    <div class="flex items-center gap-2">
                                        <span class="text-lg">{{ country.flag }}</span>
                                        <span>{{ country.name }}</span>
                                    </div>
                                </mat-option>
                            </mat-autocomplete>
                        </td>
                    </ng-container>

                    <!-- Address Column -->
                    <ng-container matColumnDef="address">
                        <th mat-header-cell *matHeaderCellDef class="font-semibold">Address</th>
                        <td mat-cell *matCellDef="let element">
                            <mat-form-field appearance="outline" class="w-full table-form-field">
                                <input matInput [formControl]="element.get('address')" placeholder="Enter address">
                            </mat-form-field>
                        </td>
                    </ng-container>

                    <!-- Actions Column -->
                    <ng-container matColumnDef="actions">
                        <th mat-header-cell *matHeaderCellDef class="font-semibold">Actions</th>
                        <td mat-cell *matCellDef="let element; let i = index">
                            <div class="flex gap-1 items-center justify-center">
                                <button mat-icon-button color="warn" (click)="removeIndividualEntity(i)"
                                    matTooltip="Remove individual" [disabled]="getEntityCount() === 1">
                                    <mat-icon>delete</mat-icon>
                                </button>
                                <div class="flex items-center justify-center">
                                    <mat-icon *ngIf="hasRowValidationErrors(element)"
                                        class="text-red-500 flex items-center justify-center"
                                        matTooltip="Has validation errors">
                                        error
                                    </mat-icon>
                                    <mat-icon *ngIf="!hasRowValidationErrors(element)"
                                        class="text-green-500 flex items-center justify-center" matTooltip="Valid">
                                        check_circle
                                    </mat-icon>
                                </div>
                            </div>
                        </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="individualDisplayedColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: individualDisplayedColumns;"
                        [class.error-row]="hasRowValidationErrors(row)"></tr>
                </table>
            </div>

            <!-- Add Individual Button -->
            <div class="flex justify-left mt-2 ml-2">
                <button mat-stroked-button (click)="addIndividualEntity()" class="flex items-center gap-2">
                    <mat-icon>add</mat-icon>
                    Add Another Individual
                </button>
            </div>
        </div>

        <!-- Vessel Bulk Table -->
        <div *ngIf="searchBy === 'Vessels'" class="bulk-table-container">
            <div class="overflow-x-auto">
                <table mat-table [dataSource]="vesselDataSource" class="w-full">

                    <!-- Vessel Name Column -->
                    <ng-container matColumnDef="name">
                        <th mat-header-cell *matHeaderCellDef class="font-semibold">Vessel Name *</th>
                        <td mat-cell *matCellDef="let element">
                            <mat-form-field appearance="outline" class="w-full table-form-field"
                                [class.invalid-field]="isFieldInvalid(element, 'name')">
                                <input matInput [formControl]="element.get('name')" placeholder="Enter vessel name">
                                <mat-error *ngIf="element.get('name')?.hasError('required')">
                                    Vessel name is required
                                </mat-error>
                            </mat-form-field>
                        </td>
                    </ng-container>

                    <!-- IMO Number Column -->
                    <ng-container matColumnDef="imoNumber">
                        <th mat-header-cell *matHeaderCellDef class="font-semibold">IMO Number *</th>
                        <td mat-cell *matCellDef="let element">
                            <mat-form-field appearance="outline" class="w-full table-form-field"
                                [class.invalid-field]="isFieldInvalid(element, 'imoNumber')">
                                <input matInput [formControl]="element.get('imoNumber')" placeholder="Enter 7-digit IMO number" maxlength="7">
                                <mat-hint>7-digit IMO number</mat-hint>
                                <mat-error *ngIf="element.get('imoNumber')?.hasError('required')">
                                    IMO number is required
                                </mat-error>
                                <mat-error *ngIf="element.get('imoNumber')?.hasError('pattern') && !element.get('imoNumber')?.hasError('required')">
                                    IMO number must be exactly 7 digits
                                </mat-error>
                            </mat-form-field>
                        </td>
                    </ng-container>

                    <!-- Actions Column -->
                    <ng-container matColumnDef="actions">
                        <th mat-header-cell *matHeaderCellDef class="font-semibold">Actions</th>
                        <td mat-cell *matCellDef="let element; let i = index">
                            <button mat-icon-button color="warn" (click)="removeVesselEntity(i)"
                                matTooltip="Remove vessel">
                                <mat-icon>delete</mat-icon>
                            </button>
                        </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="vesselDisplayedColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: vesselDisplayedColumns;"
                        [class.error-row]="hasRowValidationErrors(row)"></tr>
                </table>
            </div>

            <!-- Add Vessel Button -->
            <div class="flex justify-left mt-2 ml-2">
                <button mat-stroked-button (click)="addVesselEntity()" class="flex items-center gap-2">
                    <mat-icon>add</mat-icon>
                    Add Another Vessel
                </button>
            </div>
        </div>

        <!-- Bulk Submit Actions -->
        <div class="text-sm text-gray-500 text-left mt-14 mb-2 p-1">
            Please Review Name
            Entries Carefully. The name you enter in the search field will be queried exactly as
            provided. Please double-check the
            accuracy of the name to ensure the most relevant search results.
        </div>
        <div class="flex justify-between items-center mb-6 border-t pt-4">
            <div class="flex items-center gap-4">
                <!-- Filter Buttons -->
                <div *ngIf="validationSummary.totalRows > 0" class="flex gap-2 mr-4">
                    <!-- Valid Button -->
                    <button mat-stroked-button [color]="filterState === 'valid' ? 'primary' : 'basic'"
                        (click)="showValidRows()" [disabled]="validationSummary.validRows === 0" class="gap-1">
                        <mat-icon
                            class="text-sm text-green-600 flex items-center justify-center">check_circle</mat-icon>
                        {{ validationSummary.validRows }} valid
                    </button>

                    <!-- Invalid Button -->
                    <button mat-stroked-button [color]="filterState === 'invalid' ? 'warn' : 'basic'"
                        (click)="showInvalidRows()" [disabled]="validationSummary.invalidRows === 0"
                        class="flex items-center gap-1">
                        <mat-icon class="text-sm text-red-500 flex items-center justify-center">error</mat-icon>
                        {{ validationSummary.invalidRows }} invalid
                    </button>

                    <!-- Show All Button - only visible when a filter is active -->
                    <button *ngIf="filterState !== 'all'" mat-stroked-button color="accent" (click)="showAllRows()"
                        class="flex items-center gap-1">
                        <mat-icon>visibility</mat-icon>
                        Show All
                    </button>
                </div>
            </div>

            <div class="flex gap-2">
                <button mat-raised-button color="primary" (click)="onSubmitBulk()" [disabled]="!validateAllEntities()"
                    class="text-white">
                    Submit {{ validationSummary.validRows }} Valid {{ searchBy }}
                </button>
            </div>
        </div>
    </div>
</div>